export const AFFILIATE_BALANCE_WITHDRAWAL_ROUTE_NAME = Symbol('affiliate.balance.withdrawal');
